<template>
    <div class="staking-order-box" v-if="rightsContains('STAKING_LOCK') || rightsContains('STAKING_UNLOCK')">
        <el-tabs v-model="activeName" @tab-click="handleClick($event)">
            <el-tab-pane label="锁仓订单" name="LOCK" v-if="rightsContains('STAKING_LOCK')"></el-tab-pane>
            <el-tab-pane label="解锁订单" name="UNLOCK" v-if="rightsContains('STAKING_UNLOCK')"></el-tab-pane>
        </el-tabs>
        <div>
            <el-form inline>
                <el-form-item label="币种：" style="padding-top: 20px">
                    <el-autocomplete class="inline-input"
                                     v-model="queryParams.coinType"
                                     :fetch-suggestions="querySearch"
                                     placeholder="请输入币种">
                        <i class="el-icon-close el-input__icon" slot="suffix"
                           @click="cleanSearchCoin" style="cursor:pointer;">
                        </i>
                    </el-autocomplete>
                </el-form-item>
                <el-form-item label="状态：" style="padding-top: 20px">
                    <el-select v-model="queryParams.status" style="width: 300px">
                        <el-option v-for="item in statusArr" :key="item.value" :label="item.label"
                                   :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="下单时间：" style="padding-top: 20px">
                    <el-date-picker
                            v-model="dataArr"
                            type="datetimerange"
                            value-format="timestamp"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>

                <el-form-item style="padding-top: 20px">
                    <el-button type="primary" @click="searchData">搜索</el-button>
                </el-form-item>
            </el-form>
        </div>

        <div class="order-list" v-if="activeName=='LOCK'">
            <el-table class="order-table" border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                      :data="lockList" key="lockList" :row-key="() => Math.random()">
                <el-table-column prop="id" label="记录ID"></el-table-column>
                <el-table-column prop="userId" label="用户ID"></el-table-column>
                <el-table-column prop="stakingCoinId" label="锁仓币种ID"></el-table-column>
                <el-table-column prop="coinType" label="币种"></el-table-column>
                <el-table-column prop="amount" label="数量" show-overflow-tooltip></el-table-column>
                <el-table-column prop="status" label="状态" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{scope.row.status | lockStatusFormat}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="cancelType" label="取消类型" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.cancelType==1">后台取消</span>
                        <span v-if="scope.row.cancelType==2">用户取消</span>
                    </template>
                </el-table-column>
                <el-table-column prop="lockCycleType" label="锁仓期限类型" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{scope.row.lockCycleType | formatlockCycleType}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="cancelDescriptionJson" label="撤销原因" show-overflow-tooltip></el-table-column>
                <el-table-column label="预计开始收益时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.incomeBeginTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="锁仓时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.lockedTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="撤销时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.cancelTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="创建时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.createTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button type="danger" @click="cancleOrderDialog(scope.row)"
                                   v-if="scope.row.status==2 || scope.row.status==3">撤销
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style="margin-top: 30px"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="queryParams.page"
                           :page-sizes="[10, 20, 50, 100, 200, 500, 1000]"
                           :page-size="queryParams.size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </div>

        <div class="order-list" v-if="activeName=='UNLOCK'">
            <el-table class="order-table" border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                      :data="unlockList" key="unlockList" :row-key="() => Math.random()">
                <el-table-column prop="id" label="记录ID"></el-table-column>
                <el-table-column prop="userId" label="用户ID"></el-table-column>
                <el-table-column prop="stakingCoinId" label="锁仓币种ID"></el-table-column>
                <el-table-column prop="coinType" label="币种"></el-table-column>
                <el-table-column prop="lockCoinType" label="锁仓币种"></el-table-column>
                <el-table-column prop="amount" label="数量" show-overflow-tooltip></el-table-column>
                <el-table-column label="天数" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{scope.row.unlockDays}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="状态" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{scope.row.status | unlockStatusFormat}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="cancelType" label="取消类型" show-overflow-tooltip>
                    <template slot-scope="scope">
                            <span v-if="scope.row.cancelType==1">后台取消</span>
                            <span v-if="scope.row.cancelType==2">用户取消</span>
                    </template>
                </el-table-column>
                <el-table-column prop="cancelDescriptionJson" label="撤销原因" show-overflow-tooltip></el-table-column>
                <el-table-column label="开始时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.startUnlockTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="结束时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.endUnlockTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="撤销时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.cancelTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="创建时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.createTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="更新时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.updateTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button type="danger" @click="cancleOrderDialog(scope.row)"
                                   v-if="scope.row.status==2 || scope.row.status==3">撤销
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style="margin-top: 30px"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="queryParams.page"
                           :page-sizes="[10, 20, 50, 100, 200, 500, 1000]"
                           :page-size="queryParams.size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </div>

        <el-dialog title="撤销" :visible.sync="dialogVisible" width="50%" @close="clearData"
                   :close-on-click-modal="false">
            <div v-for="lang in languages" :key="lang.value" class="introduction-editor">
                <div class="introduction-editor-header" style="margin-top: 10px;margin-bottom: 10px">原因（{{ lang.label
                    }}）
                </div>
                <el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="description[lang.value]">
                </el-input>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogVisible=false">取 消</el-button>
                <el-button type="danger" :loading="loading" @click="cancleOrder">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import '../store';
    import {mapState} from "vuex";
    import api from '../api';
    import LANGUAGES from "../common/languages_code";
    import {STAKINGUNLOCKSTATUS, STAKINGLOCKSTATUS} from "../common/constants";
    import {RIGHTS_TYPE} from "../../../common/constant";

    export default {
        name: 'OrderManage',
        components: {},
        data() {
            return {
                activeName: "LOCK",
                lockList: [],
                unlockList: [],
                total: 0,
                queryParams: {
                    status: "",
                    coinType: "",
                    beginTime: "",
                    endTime: "",
                    page: 1,
                    size: 10,
                },
                coinTypes: [],
                dataArr: [],
                statusArr: [],
                languages: Object.keys(LANGUAGES).map(lang => ({
                    label: LANGUAGES[lang],
                    value: lang
                })),
                description: {},
                dialogVisible: false,
                currRow: {},
                loading: false
            }
        },
        filters: {
            formatlockCycleType(type) {
                switch (type) {
                    case 1:
                        return "灵活解锁";
                    default:
                        return type;
                }
            },
            lockStatusFormat(status) {
                switch (status) {
                    case 2:
                        return "等待锁仓";
                    case 3:
                        return "锁仓中";
                    case 4:
                        return "完成";
                    case -1:
                        return "已取消";
                    default:
                        return status;
                }
            },
            unlockStatusFormat(status) {
                switch (status) {
                    case 2:
                        return "等待确认";
                    case 3:
                        return "等待解锁";
                    case 4:
                        return "解锁中";
                    case 5:
                        return "完成";
                    case -1:
                        return "已取消";
                    default:
                        return status;
                }
            }
        },
        computed: {
            ...mapState(["userInfo", "userRights"])
        },
        methods: {
            rightsContains(r) {
                let rights = this.userRights.split(",") || [];
                return rights.indexOf(RIGHTS_TYPE[r]) !== -1;
            },
            handleClick(value) {
                this.initParam();
                this.queryData();
            },
            queryData() {
                if (this.activeName == "LOCK") {
                    this.getStakingLockList(this.queryParams);
                } else if (this.activeName == "UNLOCK") {
                    this.getStakingUnlockOrderList(this.queryParams);
                }
            },
            cancleOrderDialog(row) {
                this.currRow = row;
                this.dialogVisible = true;
            },
            cancleOrder() {
                if (this.activeName == "LOCK") {
                    this.cancleStakingLockOrder(this.currRow);
                } else if (this.activeName == "UNLOCK") {
                    this.cancleStakingUnlockOrder(this.currRow);
                }
            },
            searchData() {
                this.queryParams.page = 1;
                this.queryParams.beginTime = this.dataArr != null ? this.dataArr[0] : null;
                this.queryParams.endTime = this.dataArr != null ? this.dataArr[1] : null;
                this.queryData();
            },
            initParam() {
                this.lockList = [];
                this.unlockList = [];
                this.dataArr = [];
                this.total = 0;
                this.queryParams = {
                    status: "",
                    coinType: "",
                    beginTime: "",
                    endTime: "",
                    page: 1,
                    size: 10,
                };
                if (this.activeName == "LOCK") {
                    this.statusArr = STAKINGLOCKSTATUS;
                } else if (this.activeName == "UNLOCK") {
                    this.statusArr = STAKINGUNLOCKSTATUS;
                }
            },
            getAllSupportCoin() {
                api.getAllSupportCoin().then(({data}) => {
                    this.coinTypes = data;
                });
            },
            getStakingLockList(query) {
                api.getStakingLockList(query).then(({data}) => {
                    this.total = data.totalCount;
                    this.lockList = data.list;
                });
            },
            getStakingUnlockOrderList(query) {
                api.getStakingUnlockOrderList(query).then(({data}) => {
                    this.total = data.totalCount;
                    this.unlockList = data.list;
                });
            },
            cancleStakingLockOrder(row) {
                if (!this.vaildReason()) {
                    return
                }
                this.$confirm('确认要对锁仓订单撤销吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.cancleStakingLockOrder({
                        id: row.id,
                        cancelDescriptionJson: JSON.stringify(this.description)
                    }).then((data) => {
                        if (data.code == 0) {
                            this.dialogVisible = false;
                            this.getStakingLockList(this.queryParams);
                            this.$message.success('撤销成功!');
                        } else {
                            this.$message.success(data.msg);
                        }
                    });
                }).catch(() => {
                });
            },
            cancleStakingUnlockOrder(row) {
                if (!this.vaildReason()) {
                    return
                }
                this.$confirm('确认要对解锁订单撤销吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.cancleStakingUnlockOrder({
                        id: row.id,
                        cancelDescriptionJson: JSON.stringify(this.description)
                    }).then((data) => {
                        if (data.code == 0) {
                            this.dialogVisible = false;
                            this.getStakingUnlockOrderList(this.queryParams);
                            this.$message.success('撤销成功!');
                        } else {
                            this.$message.success(data.msg);
                        }
                    });
                }).catch(() => {
                });
            },
            vaildReason() {
                for (let lang in LANGUAGES) {
                    if (this.description[lang] == "") {
                        this.$message.info('撤销原因（' + LANGUAGES[lang] + '）不能为空!');
                        return false;
                    }
                }
                return true;
            },
            handleSizeChange(val) {
                this.queryParams.size = val;
                this.queryData();
            },
            handleCurrentChange(val) {
                this.queryParams.page = val;
                this.queryData();
            },
            querySearch(queryString, cb) {
                var results = [];
                var coinList = this.coinTypes;
                results = queryString ? coinList.filter(this.createFilter(queryString)) : coinList;
                results = results.map((v, i, arr) => {
                    return {
                        value: v
                    }
                });
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                let tempData = this.coinTypes;
                return (tempData) => {
                    return (tempData.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            cleanSearchCoin() {
                this.queryParams.coinType = '';
            },
            clearData() {
                this.dialogVisible = false;
                this.initData();
            },
            initData() {
                Object.keys(LANGUAGES).map(lang => {
                    this.description[lang] = "";
                })
            },
        },
        created() {
            this.getAllSupportCoin();
            this.initParam();
            this.initData();
            if (this.rightsContains('STAKING_UNLOCK')) {
                this.activeName = "UNLOCK"
            }
            if (this.rightsContains('STAKING_LOCK')) {
                this.activeName = "LOCK"
            }
            this.queryData();
        }
    };
</script>

<style lang="less" scoped>
    .staking-order-box {
        .order-list {
            border: 1px solid #f2ece2;
            clear: both;
            width: 100%;
            .order-table {
                margin-top: 30px;
            }
        }
    }
</style>

